import { render } from "./createLeadForm.vue?vue&type=template&id=6940ddb8&scoped=true"
import script from "./createLeadForm.vue?vue&type=script&lang=js"
export * from "./createLeadForm.vue?vue&type=script&lang=js"

import "./createLeadForm.vue?vue&type=style&index=0&id=6940ddb8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6940ddb8"]])

export default __exports__